import { Sparkle } from "lucide-react";

export const Marquee = ({ items, className = "" }) => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className={`overflow-hidden border-y border-slate-100 bg-white py-5 ${className}`}
  >
    <div className="animate-marquee flex w-max items-center gap-10 hover:[animation-play-state:paused]">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="whitespace-nowrap font-heading text-base sm:text-lg font-semibold tracking-wide text-navy-800/60">
            {item}
          </span>
          <Sparkle className="h-4 w-4 shrink-0 text-emerald-500" />
        </span>
      ))}
    </div>
  </div>
);
